module.exports = __webpack_public_path__ + "img/CliAcneSet2.700860df.jpg";